export function Footer() {
  return (
    <footer className="site-footer">
      <span>© 2026 Wendo</span>
      <span>不保存用户历史文件</span>
    </footer>
  );
}
